// import React from 'react';
// import {Link} from 'react-router';
// import {Menu} from 'antd';
// import {layout} from 'icsoc-antd-ex';

// const {BaseContent, BaseContentMain, BaseContentSider} = layout;

// const SystemSetting = ({
//   children,
//   location: {pathname = '/systemSetting/workTime'} = {},
// }) => {
//   // const {user} = this.props.location.state;

//   const defaultSelectedKeys =
//     (pathname === '/systemSetting' ? '/systemSetting/workTime' : pathname) ||
//     '/systemSetting/workTime';

//   const baseContentSiderRender = (
//     <BaseContentSider
//       title="系统设置"
//       selectedKeys={[defaultSelectedKeys]}
//       mode="inline">
//       <Menu.Item key="/systemSetting/workTime">
//         <Link to="/systemSetting/workTime">工作时间</Link>
//       </Menu.Item>
//       <Menu.Item key="/systemSetting/talkingSkill">
//         <Link to="/systemSetting/talkingSkill">话术列表</Link>
//       </Menu.Item>
//       {/* {user.profile.role_type === '1' ? ( */}
//       <Menu.Item key="/systemSetting/callingNumber">
//         <Link to="/systemSetting/callingNumber">主叫号码</Link>
//       </Menu.Item>
//       {/* ) : null} */}
//       <Menu.Item key="/systemSetting/exportTasks">
//         <Link to="/systemSetting/exportTasks">数据导出任务</Link>
//       </Menu.Item>
//       <Menu.Item key="/systemSetting/newRole">
//         <Link to="/systemSetting/newRole">角色管理</Link>
//       </Menu.Item>
//     </BaseContentSider>
//   );

// return (
// <BaseContent>
//   {baseContentSiderRender}
//   <BaseContentMain>{children}</BaseContentMain>
// </BaseContent>
//   );
// };

import React from 'react';

class SystemSetting extends React.PureComponent {
  componentDidMount() {}

  render() {
    const {children} = this.props;
    return <div className="container sysmanage-container">{children}</div>;
  }
}

export default SystemSetting;
